import React from "react";
import Logo from "../../../../client/src/Static/RoundedRTSIcon.png";

function Loader() {
  return (
    <>
      <div class="flex-col gap-4 w-full flex items-center justify-center">
        <div class="!w-20 !h-20 border-8 text-[#151C62] text-3xl animate-spin border-gray-300 flex items-center justify-center border-t-blue-800 rounded-full">
          <img src={Logo} alt="Logo" className="w-full h-full" />
        </div>
      </div>
    </>
  );
}

export default Loader;
